// removeFilterNode — VQE-Edit edit-action: remove the leaf or group at a
// NodePath from the WHERE tree (with its adjacent connector). Delegates to
// `commitEdit` with a `remove-where-node` SR-Edit op.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — add/modify/remove
// filter (WHERE / HAVING).

import type { BooleanClauseTarget, NodePath } from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Remove the leaf or group at `path` (with its adjacent connector) from the
 * WHERE (default) or HAVING (`clause: 'having'`) tree.
 */
export async function removeFilterNode(
  path: NodePath,
  ctx: CommitEditCtx,
  clause?: BooleanClauseTarget,
): Promise<void> {
  if (path.length === 0) return;
  await commitEdit({ op: 'remove-where-node', path, clause }, ctx);
}
